import { createTypes, createAsyncTypes } from '../../utils';

const types = createTypes('footer', [
    'OPEN_FEEDBACK_DIALOG',
    'CLOSE_FEEDBACK_DIALOG',
    'SHOW_CHAT_BUTTON',
    'HIDE_CHAT_BUTTON',
]);

const asyncTypes = createAsyncTypes('footer', [
    'FETCH_FOOTER',
]);

export default {
    ...types,
    ...asyncTypes
};
